import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-house',
  templateUrl: './coachmark-house.component.html',
  styleUrls: ['./coachmark-house.component.scss']
})
export class CoachmarkHouseComponent implements OnInit {
  show: boolean;
  selectedTab: number;
  constructor(private sessionStateService: SessionStateService) { }

  ngOnInit() {
    this.selectedTab = 1;
    this.moveMsg();
  }

  nextTab() {
    if (this.selectedTab === 1) {
      const bottomHeaderElem = document.getElementsByClassName('bottomHeader')[0];
      bottomHeaderElem.classList.remove('coach');
      const buttonProfileHouseElem = document.getElementsByClassName('buttonProfileHouse')[0];
      const elemPosition: ClientRect = buttonProfileHouseElem.getBoundingClientRect();
      if ($('#coachmarkTips').length === 1) {
        $('#coachmarkTips').css('left', elemPosition.left - 15 )
          .css('top', elemPosition.top + window.scrollY + 90 )
          .css('display', 'block');
      }
      buttonProfileHouseElem.parentElement.classList.add('coachMarkViewTip');
      this.selectedTab++;
    }
  }

  moveMsg() {
    const waitRendering =  setInterval( () => {
       const elem = document.getElementsByClassName('bottomHeader')[0];
       if (elem) {
         const elemPosition: ClientRect = elem.getBoundingClientRect();
           if ($('#coachmarkTips').length === 1) {
             $('#coachmarkTips').css('left', elemPosition.left)
               .css('top', elemPosition.top + window.scrollY + 110 )
               .css('display', 'block');
           }
           this.show = true;
           clearInterval(waitRendering);
       }
     }, 2000);
  }

  gotIt() {
    this.skipHelpTips();
  }

  skipHelpTips() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('house', false));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-house/coachmark-house.component.ts